import { combineReducers } from 'redux';
import { releaseNotesReducer } from './reducers/release-notes-reducer';
import { latestVersionReducer } from './reducers/latest-version-reducer';


export default combineReducers({
  releaseNotesReducer,
  latestVersionReducer
});